/* ══════════════════════════════════════════════════════════════════════════════════════════════════
   MNL — ADAPTATEUR DE THÈME POUR LA CONVERSION DE DOSE. V1259 — 06/08/2026.
   ══════════════════════════════════════════════════════════════════════════════════════════════════

   CE FICHIER NE CONVERTIT RIEN. Il ne contient AUCUNE table de doses, AUCUN plafond, AUCUN palier.
   Il traduit, et c'est tout : libellé français ↔ clé interne, unité d'affichage ↔ milligrammes,
   date d'archive ↔ grille en vigueur ce jour-là. La conversion elle-même est TOUJOURS déléguée à
   MNL_DOSES (assets/mnl-dose-conversion.js), fichier unique du projet.

   ── POURQUOI IL EXISTE ────────────────────────────────────────────────────────────────────────────
   Six surfaces du thème convertissaient des doses chacune dans son coin — configurateur, Coach IA,
   « Mes formules » du compte, « Recommander » d'une commande, widget « Re-commander » de l'accueil,
   partage de formule de la fiche produit. Elles ne divergeaient pas sur l'algorithme (celui-là est
   dans MNL_DOSES) mais sur TOUT CE QUI L'ENTOURE : quatre copies de la table « Caféine → caffeine »,
   trois copies de « citrulline s'affiche en g », deux conventions de lecture pour « 6 » sans unité.
   Une passe qui corrige une de ces copies laisse les trois autres. D'où ce fichier : un seul jeu de
   traductions, chargé partout, et une seule porte d'entrée vers MNL_DOSES.

   ⚠ SI CE FICHIER GROSSIT D'UNE TABLE DE DOSES, C'EST QU'IL A ÉCHOUÉ. Toute valeur de dose, de cran
     ou de plafond appartient à MNL_DOSES. Ici on ne trouve que des NOMS, des UNITÉS et des DATES.

   ── LES DATES : POURQUOI SEULEMENT TROIS ACTIFS ───────────────────────────────────────────────────
   Deux surfaces possèdent la DATE de la formule (`f.ts` des archives localStorage, `order.created_at`
   d'une commande). Une date permet une conversion EXACTE là où `fromMg` doit deviner : on sait quelle
   grille était en vigueur ce jour-là, donc on connaît l'INDICE, et l'indice est ce qui est facturé.
   Les seuils ci-dessous sont ceux DÉJÀ déployés dans sections/page-account.liquid (ACC_GLY_BRIDAGE_TS,
   ACC_V1236_TS, ACC_V1253_TS) : ils ne sont pas inventés ici, ils sont repris.
   Les trois actifs concernés sont les trois SEULS dont on connaisse la date exacte de changement
   d'échelle. Le sel rose (V1171) et la pipérine (V1134) ont eux aussi changé d'échelle, mais leur
   date n'est écrite nulle part dans le dépôt : on ne l'invente PAS, et `fromMg` les traite très bien
   par la seule portée de la valeur (régime 2 du module). Une date fausse serait pire qu'une absence
   de date — elle convertirait avec assurance dans la mauvaise grille.
   ══════════════════════════════════════════════════════════════════════════════════════════════════ */
(function (root, factory) {
  var api = factory();
  try { root.MNL_DOSE_THEME = api; } catch (_) {}
  try { if (typeof module === 'object' && module.exports) module.exports = api; } catch (_) {}
}(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  'use strict';

  function MD() {
    var d = (typeof globalThis !== 'undefined' && globalThis.MNL_DOSES) ||
            (typeof window !== 'undefined' && window.MNL_DOSES) || null;
    return (d && typeof d.fromMg === 'function' && d.CURRENT) ? d : null;
  }

  /* Le module est-il là ? Toute surface qui calcule un PRIX doit poser cette question AVANT de
     calculer, pas après (cf. le « défaut B » de la passe V1259 : le configurateur dégradait en
     silence quand bilan/quiz/recharge, eux, refusaient de démarrer). */
  function ready() { return MD() !== null; }

  /* Refus explicite et nommé. `who` apparaît dans le message : on doit pouvoir lire dans la console
     QUELLE surface a refusé, sans deviner. */
  function requireModule(who) {
    var d = MD();
    if (!d) {
      throw new Error('[MNL] mnl-dose-conversion.js absent — ' + (who || 'cette surface') +
        ' REFUSE de continuer : sans conversion, elle afficherait un prix calculé sur des doses non converties.');
    }
    return d;
  }

  /* ── NOMS ─────────────────────────────────────────────────────────────────────────────────────────
     Libellés vus par le client (Coach, propriétés de ligne Shopify, archives localStorage) → clés
     internes. Les archives portent des millésimes de libellés différents (« Bêta-alanine » écrit par
     le modèle, « Béta-Alanine » dans la matrice du Coach, « Caféine Anhydre » dans les propriétés du
     configurateur) : on compare donc sur une forme réduite, sans accents ni ponctuation.
     ⚠ La bétaïne est ABSENTE de cette table : l'actif est sorti du produit (V1135/V1136) et ne doit
       jamais être ré-injecté dans une commande. Sa CLÉ reste vivante dans MNL_DOSES (position 7 des
       QR imprimés) — c'est le module qui la neutralise, pas nous. */
  var ALIAS = {
    cafeine: 'caffeine', caffeine: 'caffeine', cafeineanhydre: 'caffeine', caffeineanhydre: 'caffeine',
    theanine: 'theanine', ltheanine: 'theanine',
    tyrosine: 'tyrosine', ltyrosine: 'tyrosine',
    citrulline: 'citrulline', lcitrulline: 'citrulline', citrullinemalate: 'citrulline',
    glycerol: 'glycerol', glycerine: 'glycerol', glycerolmonostearate: 'glycerol',
    selrose: 'pinksalt', selrosehimalaya: 'pinksalt', selrosedelhimalaya: 'pinksalt', pinksalt: 'pinksalt',
    betaalanine: 'betaalanine', balanine: 'betaalanine',
    taurine: 'taurine',
    creatine: 'creatine', creatinemonohydrate: 'creatine',
    electrolytes: 'electrolytes', electrolyte: 'electrolytes', mixelectrolytes: 'electrolytes',
    /* V1283 (07/08/2026) : le LIBELLÉ CLIENT est devenu « Complexe électrolytique » — la vitrine et
       l'étiquette ne nomment plus K, Mg et Na, qui ne sont pas présents en quantité significative
       (15 % de la VNR). La CLÉ de commande, elle, reste « Électrolytes (K · Mg · Na) ».
       CET ALIAS EST OBLIGATOIRE, et la passe 2 ne l'aurait PAS rattrapé : elle teste si le libellé
       réduit COMMENCE par une clé connue, or « complexeelectrolytique » commence par « complexe »,
       qui n'est alias de rien. Sans cette ligne, toute surface qui lit le libellé affiché au lieu de
       la propriété rendrait une « dose ILLISIBLE ». */
    complexeelectrolytique: 'electrolytes', complexeelectrolyte: 'electrolytes',
    piperine: 'piperine', bioperine: 'piperine'
  };

  /* Libellé CANONIQUE par clé — celui qu'on RÉÉCRIT dans une propriété de ligne ou une carte.
     Il doit rester celui que le Coach et le configurateur emploient déjà, sinon deux formules
     identiques s'afficheraient sous deux noms. */
  var LABEL = {
    caffeine: 'Caféine', theanine: 'L-Théanine', tyrosine: 'L-Tyrosine', citrulline: 'L-Citrulline',
    glycerol: 'Glycérol', pinksalt: 'Sel rose', betaalanine: 'Béta-Alanine', taurine: 'Taurine',
    creatine: 'Créatine', electrolytes: 'Électrolytes', piperine: 'Pipérine'
  };

  /* Unité D'AFFICHAGE de chaque actif (celle du curseur du configurateur et des propriétés de ligne).
     Ce n'est PAS une donnée de dosage : c'est la façon dont on écrit le nombre. */
  var UNIT = {
    caffeine: 'mg', theanine: 'mg', tyrosine: 'mg', citrulline: 'g', glycerol: 'g', pinksalt: 'mg',
    betaalanine: 'g', taurine: 'mg', creatine: 'g', electrolytes: 'mg', piperine: 'mg'
  };

  /* Clés d'ALIAS triées de la PLUS LONGUE à la plus courte : le repli par préfixe ci-dessous doit
     essayer « creatinemonohydrate » avant « creatine », sinon le plus court gagnerait toujours. */
  var ALIAS_KEYS = Object.keys(ALIAS).sort(function (a, b) { return b.length - a.length; });

  /* Libellé → clé interne. Deux passes, et la seconde n'est pas un luxe :
     les libellés réels diffèrent selon la surface qui les a écrits. Le Coach dit « Électrolytes »,
     mais les propriétés de ligne du configurateur disent « Électrolytes (K · Mg · Na) » et sa fiche
     dit « Mix Électrolytes (K · Mg · Na) » — réduits, ça donne electrolytes / electrolyteskmgna /
     mixelectrolyteskmgna. Idem « Caféine Anhydre », « Créatine Monohydrate », « Sel Rose Himalaya ».
     Une table d'égalité stricte manquerait donc les actifs sur la porte la plus grave, celle du
     rachat de commande — où une dose non reconnue repart NON CONVERTIE en production.
     PASSE 1 : égalité stricte (rapide, et fait foi).
     PASSE 2 : préfixe, la plus longue clé d'abord. « electrolyteskmgna » commence par
     « electrolytes » → electrolytes. Sans risque de collision : aucune clé d'alias n'est le préfixe
     d'un autre actif (betaalanine ≠ betaine, ltheanine ≠ theanine sont départagés par la passe 1). */
  function keyFromLabel(name) {
    var s = String(name == null ? '' : name).toLowerCase();
    try { s = s.normalize('NFD').replace(new RegExp('[\\u0300-\\u036F]', 'g'), ''); } catch (_) {}
    s = s.replace(/[^a-z]/g, '');
    if (!s) return '';
    if (Object.prototype.hasOwnProperty.call(ALIAS, s)) return ALIAS[s];
    for (var i = 0; i < ALIAS_KEYS.length; i++) {
      if (s.indexOf(ALIAS_KEYS[i]) === 0) return ALIAS[ALIAS_KEYS[i]];
    }
    return '';
  }

  /* « 8 g » → 8000. « 150 » → 150. Convention du dépôt : UNITÉ ABSENTE ⇒ mg (identique à _doseToMg du
     Coach et _accDoseToMg du compte — deux surfaces qui liraient « 6 » différemment finiraient par se
     contredire). Rend null si rien de lisible : on ne fabrique jamais un chiffre. */
  function mgOf(raw, k) {
    var m = String(raw == null ? '' : raw).match(/([\d.,]+)\s*(mg|g)?/i);
    if (!m) return null;
    var v = parseFloat(m[1].replace(',', '.'));
    if (!isFinite(v) || v < 0) return null;
    var unite = (m[2] || '').toLowerCase();
    /* V1296 (audit 09/08) : « 6 » SANS UNITÉ sur un actif qui se dose en GRAMMES était lu en mg
       (convention du dépôt : nombre nu = mg) → citrulline « 6 » devenait 6 mg → la carte affichait
       « 0 g ». L'erreur vient du MODÈLE (le Coach a omis l'unité), pas du client. Réparation ÉTROITE
       et sans collision possible : pour les quatre actifs en g (citrulline, glycérol, bêta-alanine,
       créatine), leur plus petit cran RÉEL est ≥ 500 mg ; un nombre nu ≤ 20 ne peut donc PAS être des
       milligrammes (20 mg n'est un cran d'aucun d'eux) — c'est forcément des grammes. Au-delà de 20
       (« 6000 »), c'est bien des mg : le comportement d'origine tient. Sans clé (`k` absent, appelant
       externe), rien ne change — la réparation ne s'arme que quand on SAIT que l'actif est en g. */
    if (!unite && k && UNIT[k] === 'g' && v > 0 && v <= 20) return v * 1000;
    return unite === 'g' ? v * 1000 : v;
  }

  /* mg → valeur dans l'unité d'affichage de l'actif, et retour. */
  function toDisplay(k, mg) { return UNIT[k] === 'g' ? Math.round(mg / 100) / 10 : Math.round(mg * 100) / 100; }
  function toMg(k, val) { return UNIT[k] === 'g' ? val * 1000 : val; }
  function fmtDose(k, val) { return (Math.round(val * 1000) / 1000) + ' ' + (UNIT[k] || 'mg'); }

  /* ── DATES DE CHANGEMENT D'ÉCHELLE ────────────────────────────────────────────────────────────────
     Repris tels quels de sections/page-account.liquid (déjà déployés). Bornés au JOUR de la décision
     fondateur, même convention que V1236/V1253. */
  var TS_V1228 = Date.UTC(2026, 7, 3);   /* 03/08/2026 — glycérol 8 g → 4 g   (V1226/V1228/V1230) */
  var TS_V1236 = Date.UTC(2026, 7, 4);   /* 04/08/2026 — théanine 400 → 200 mg, glycérol 4 g → 3 g */
  var TS_V1253 = Date.UTC(2026, 7, 5);   /* 05/08/2026 — taurine 2000 → 1000 mg (V1246/V1253)     */
  var TS_V1271 = Date.UTC(2026, 7, 6);   /* 06/08/2026 — tyrosine 2000 → 1000 mg (V1271)          */

  /* Grille EN VIGUEUR pour l'actif `k` à la date `ts`, choisie PARMI LES TABLES DU MODULE — aucune
     table n'est écrite ici. Rend null quand la date n'apprend rien de plus que la valeur elle-même
     (huit actifs sur onze) : l'appelant retombe alors sur fromMg, qui est fait pour ça. */
  function eraGrid(k, ts) {
    var d = MD(); if (!d) return null;
    var t = Number(ts);
    if (!isFinite(t)) return null;                 /* archive sans date → fromMg */
    if (k === 'glycerol') {
      if (t >= TS_V1236) return null;              /* déjà l'échelle du jour */
      if (t >= TS_V1228) return d.GRIDS[3].glycerol;   /* [0,1,1.5,2,3,4]  — ère V1228/V1230 */
      return d.UNIV.glycerol;                          /* [0,2,3,5,6,8]    — ère pré-V1228   */
    }
    if (k === 'theanine') {
      if (t >= TS_V1236) return null;
      return d.GRIDS[3].theanine;                      /* [0,50,100,200,300,400] */
    }
    if (k === 'taurine') {
      if (t >= TS_V1253) return null;
      return d.GRIDS[4].taurine;                       /* [0,250,500,1000,1500,2000] */
    }
    /* ⚠ V1271 — LA TYROSINE REJOINT LES ACTIFS DATÉS, ET IL FALLAIT QU'ELLE LE FASSE.
       Tant que son échelle n'avait jamais bougé, la date n'apprenait rien de plus que la valeur, et
       fromMg suffisait. Depuis l'abaissement 2000 → 1000 mg, ce n'est plus vrai POUR LES QUATRE CRANS
       BAS : 250, 500, 750 et 1000 mg sont des doses encore LÉGALES aujourd'hui, donc fromMg les rend
       INTACTES (régime 2, « ambiguïté assumée ») — et une archive à 1000 mg, qui était le cran 3 de
       l'échelle sortante, ressortirait au cran 5, LE PLUS CHER. Un cran de plus pour la même dose :
       exactement le défaut que la conversion à indice constant existe pour éviter.
       La date lève l'ambiguïté : avant le 06/08/2026, une tyrosine se lit dans GRIDS[5] et son INDICE
       est reporté. Après, l'échelle est déjà celle du jour → null → fromMg, inchangé.
       (Le garde-fou « la date peut mentir » ci-dessous reste actif : une valeur > 2000 mg, impossible
       même dans l'échelle sortante, rend la main à fromMg.) */
    if (k === 'tyrosine') {
      if (t >= TS_V1271) return null;
      return d.GRIDS[5].tyrosine;                      /* [0,250,500,1000,1500,2000] */
    }
    return null;
  }

  /* ── LA CONVERSION, EN UN SEUL POINT D'ENTRÉE ────────────────────────────────────────────────────
     ⚠⚠ PIÈGE D'UNITÉ, À LIRE AVANT D'APPELER MNL_DOSES DIRECTEMENT ⚠⚠
     `MNL_DOSES.fromMg` porte un nom TROMPEUR : il ne travaille PAS en milligrammes, il travaille dans
     l'unité NATIVE de chaque actif — celle de ses grilles. CURRENT.caffeine = [0,50,…,200] est en mg,
     mais CURRENT.citrulline = [0,2,3,4,6,8] est en GRAMMES, comme le glycérol, la bêta-alanine et la
     créatine. Lui passer des milligrammes pour ces quatre actifs-là écrase la dose sur le DERNIER
     cran sans rien signaler : `fromMg('citrulline', 8000)` rend 8 — le sommet — quelle que soit la
     dose d'origine, et `fromMg('glycerol', 5000)` rend 3 au lieu de 1,5. C'est très exactement le
     défaut « payer un cran de plus pour une dose de moins », introduit par une simple confusion
     d'unité. (Même famille que le défaut V996 du pont Coach → configurateur : « 5 g » encodé en 5000.)
     CONSÉQUENCE : ce fichier travaille en UNITÉ D'AFFICHAGE partout, et c'est la seule façon d'appeler
     le module. Les surfaces qui lisent des chaînes (« 8 g », « 200 mg ») passent par mgOf() PUIS
     toDisplay() — ou plus simplement par convertRaw(), qui fait les deux.

     `val` est dans l'unité D'AFFICHAGE de l'actif, `ts` est facultatif (millisecondes).
     · Date connue ET actif daté  → on lit l'INDICE dans la grille de l'époque et on le REPORTE tel
                                    quel sur la grille du jour. C'est exact, pas probable.
     · sinon                      → MNL_DOSES.fromMg (régime 2 : intacte si possible aujourd'hui,
                                    replacée sur son cran si elle ne peut venir que d'une ancienne
                                    échelle).
     Dans les deux cas c'est l'INDICE qui voyage, jamais la valeur écrêtée. */
  function convert(k, val, ts) {
    var d = requireModule('MNL_DOSE_THEME.convert');
    if (!d.CURRENT[k]) return 0;                   /* actif hors produit (bétaïne) → dose nulle */
    var v = Number(val);
    if (!isFinite(v) || v <= 0) return 0;
    var G = eraGrid(k, ts);
    /* ⚠ LA DATE PEUT MENTIR, LA VALEUR NON. Les seuils ci-dessus ont une granularité au JOUR, alors
       qu'un déploiement a une heure : une archive horodatée le 03/08 au matin peut porter une dose
       que la grille du 03/08 au soir ne permet plus (5 g de glycérol quand le plafond vient de
       tomber à 4 g). Sans ce garde-fou, on chercherait 5 g dans [0,1,1.5,2,3,4], on trouverait le
       cran 5 — le PLUS CHER — pour la dose la plus forte de l'ancienne échelle : le défaut même que
       cette passe corrige, réintroduit par la porte de la date.
       RÈGLE : une valeur que la grille de l'époque supposée ne peut PAS porter prouve que l'archive
       est plus ancienne que sa date ne le dit. On rend alors la main à fromMg, qui choisit l'échelle
       par la seule portée de la valeur — un raisonnement qui ne dépend d'aucune horloge. */
    if (G && G.length && v <= G[G.length - 1]) {
      var i = d.nearestIndex(G, v);
      if (i < 1) i = 1;                            /* un actif présent ne retombe pas à 0 */
      return d.doseAt(k, i);                       /* report d'indice sur la grille courante */
    }
    return d.fromMg(k, v);                         /* (unité native — cf. l'avertissement ci-dessus) */
  }

  /* Entrée en MILLIGRAMMES, sortie en milligrammes. Enveloppe de confort pour les appelants qui ont
     déjà converti une chaîne en mg ; passe par l'unité d'affichage, donc sans le piège ci-dessus. */
  function convertMg(k, mg, ts) {
    var v = Number(mg);
    if (!isFinite(v) || v <= 0) return 0;
    return toMg(k, convert(k, toDisplay(k, v), ts));
  }

  /* Entrée en CHAÎNE telle qu'elle vit dans une archive ou une propriété de ligne (« 8 g », « 200 mg »,
     « 150 »), sortie en unité d'affichage. Rend null si la chaîne n'a rien de lisible. */
  function convertRaw(k, raw, ts) {
    var mg = mgOf(raw, k);  /* V1296 : la clé permet de lire « 6 » comme 6 g sur un actif en grammes */
    if (mg == null) return null;
    return convert(k, toDisplay(k, mg), ts);
  }

  /* Aligne une dose DÉJÀ du jour sur le cran le plus proche de la grille courante, dans l'unité
     d'affichage de l'actif. Sert aux tables du thème dont une valeur a été écrite hors grille : le
     prix se lit au CRAN, donc une dose entre deux crans facture le cran voisin tout en affichant
     autre chose — et un aller-retour par un QR (qui n'encode QUE l'indice) la ramènerait au cran
     sans prévenir. Snapper à l'écriture rend ce détour visible et stable.
     ⚠ CE N'EST PAS UNE CONVERSION D'ANCIENNETÉ : la valeur est réputée être du jour. Pour une dose
       d'archive, c'est convertMg qu'il faut appeler, jamais celle-ci. */
  function snapToRung(k, val) {
    var d = requireModule('MNL_DOSE_THEME.snapToRung');
    if (!d.CURRENT[k]) return 0;
    var v = Number(val);
    if (!isFinite(v) || v <= 0) return 0;
    return d.doseAt(k, d.indexOf(k, v));           /* unité d'affichage de bout en bout */
  }

  /* ── OBJET « actifs » ENTIER ──────────────────────────────────────────────────────────────────────
     Entrée : { 'Caféine': '200 mg', 'Glycérol': '8 g', … } tel qu'il vit dans les archives et dans
     les propriétés de ligne. Sortie : le même objet, libellés canoniques, doses du jour.
     Tout actif hors liste blanche est ÉCARTÉ (bétaïne retirée du produit, ou clé injectée par un
     localStorage altéré) : on n'envoie jamais en production un actif que le produit ne contient plus. */
  function normalizeActifs(actifs, ts) {
    requireModule('MNL_DOSE_THEME.normalizeActifs');
    var out = {};
    if (!actifs || typeof actifs !== 'object') return out;
    Object.keys(actifs).forEach(function (rawName) {
      var k = keyFromLabel(rawName);
      if (!k) return;
      if (Object.prototype.hasOwnProperty.call(out, LABEL[k])) return;  /* doublon de libellé : la 1re entrée fait foi */
      var v = convertRaw(k, actifs[rawName], ts);
      if (v == null) return;                        /* dose illisible : on n'invente pas un chiffre */
      if (!(v > 0)) return;                         /* dose nulle → actif absent, pas « 0 mg » */
      out[LABEL[k]] = fmtDose(k, v);
    });
    return out;
  }

  /* Même travail sur un objet de doses PAR CLÉ et EN UNITÉ D'AFFICHAGE ({caffeine:200, citrulline:8}),
     qui est la forme du `d` des liens ?f= et de la propriété _recharge. */
  function normalizeDoses(doses, ts) {
    requireModule('MNL_DOSE_THEME.normalizeDoses');
    var out = {};
    if (!doses || typeof doses !== 'object') return out;
    Object.keys(doses).forEach(function (k) {
      if (!UNIT[k]) return;                         /* clé inconnue ou actif retiré → écartée */
      var v = Number(doses[k]);
      if (!isFinite(v) || v <= 0) { out[k] = 0; return; }
      out[k] = convert(k, v, ts);                   /* déjà en unité d'affichage */
    });
    return out;
  }

  /* Témoin positif : empreinte du MODULE (pas de la nôtre — nous n'avons pas de table à empreindre)
     plus la liste des traductions, pour qu'une console montre d'un coup ce que cette page a chargé. */
  function selfTest() {
    var d = MD();
    if (!d) return { ok: false, raison: 'MNL_DOSES absent' };
    var cas = [
      /* Les quatre premiers cas sont ceux qui n'existent QUE grâce à la date : sans elle, 5 g de
         glycérol seraient rendus intacts (ils sont sous le plafond… de l'ancienne grille). */
      ['archive pré-03/08 glycérol 5 g → cran 3 → 1,5 g', convert('glycerol', 5, TS_V1228 - 1), 1.5],
      ['archive 03/08 glycérol 4 g → cran 5 → 3 g', convert('glycerol', 4, TS_V1228), 3],
      ['archive 03/08 glycérol 2 g → cran 3 → 1,5 g', convert('glycerol', 2, TS_V1228), 1.5],
      /* La date dit 03/08 mais 5 g n'existait déjà plus ce jour-là : la VALEUR prouve que l'archive
         est plus ancienne. On doit retomber sur le cran 3 (1,5 g), pas sur le cran 5. */
      ['date en retard sur la valeur : glycérol 5 g daté 03/08', convert('glycerol', 5, TS_V1228), 1.5],
      ['archive pré-03/08 glycérol 8 g → cran 5 → 3 g', convert('glycerol', 8, TS_V1228 - 1), 3],
      ['archive pré-04/08 théanine 300 mg → cran 4 → 150', convert('theanine', 300, TS_V1236 - 1), 150],
      ['archive pré-05/08 taurine 1500 mg → cran 4 → 750', convert('taurine', 1500, TS_V1253 - 1), 750],
      /* V1271 — LE CAS QUI N'EXISTE QUE GRÂCE À LA DATE, POUR LA TYROSINE. 1000 mg est encore une dose
         LÉGALE aujourd'hui : sans date, fromMg la rend intacte et elle atterrit au cran 5, le plus
         cher. Datée d'avant le 06/08, elle est lue au cran 3 de l'échelle sortante et rendue à 500 mg
         — même cran, moitié de dose. C'est la différence entre convertir et écrêter. */
      ['archive pré-06/08 tyrosine 1000 mg → cran 3 → 500', convert('tyrosine', 1000, TS_V1271 - 1), 500],
      ['archive pré-06/08 tyrosine 2000 mg → cran 5 → 1000', convert('tyrosine', 2000, TS_V1271 - 1), 1000],
      ['tyrosine du jour (1000 mg, sans date) intacte', convert('tyrosine', 1000), 1000],
      ['sans date, sel rose 750 mg → cran 4 → 400', convert('pinksalt', 750), 400],
      ['sans date, pipérine 5 mg → cran 2 → 1', convert('piperine', 5), 1],
      ['dose du jour intacte (taurine 1000)', convert('taurine', 1000), 1000],
      /* LE PIÈGE D'UNITÉ, VERROUILLÉ PAR UN CAS : la citrulline est en GRAMMES. Un appelant qui
         passerait 8000 (des mg) obtiendrait 8 sans le moindre avertissement — d'où convertMg(). */
      ['citrulline 8 g reste 8 g (unité native)', convert('citrulline', 8), 8],
      ['convertMg(citrulline, 8000 mg) = 8000 mg', convertMg('citrulline', 8000), 8000],
      ['convertRaw(glycérol, « 5 g », pré-03/08) = 1,5', convertRaw('glycerol', '5 g', TS_V1228 - 1), 1.5],
      /* Les libellés RÉELS des trois surfaces — ce sont ceux-là qui arrivent en production, pas les
         formes courtes. « Électrolytes (K · Mg · Na) » est le nom des propriétés de ligne du
         configurateur : le manquer laisserait passer un actif NON CONVERTI dans un rachat. */
      ['libellé « Bêta-alanine » → betaalanine', keyFromLabel('Bêta-alanine'), 'betaalanine'],
      ['libellé « Beta-Alanine » (configurateur)', keyFromLabel('Beta-Alanine'), 'betaalanine'],
      ['libellé « Caféine Anhydre » → caffeine', keyFromLabel('Caféine Anhydre'), 'caffeine'],
      ['libellé « Électrolytes (K · Mg · Na) »', keyFromLabel('Électrolytes (K · Mg · Na)'), 'electrolytes'],
      ['libellé « Mix Électrolytes (K · Mg · Na) »', keyFromLabel('Mix Électrolytes (K · Mg · Na)'), 'electrolytes'],
      /* V1283 : le libellé CLIENT du jour. Il n'a aucune lettre en commun avec la clé de commande,
         donc seul un alias explicite le résout — ce cas-ci le prouve à chaque chargement. */
      ['libellé « Complexe électrolytique » (V1283)', keyFromLabel('Complexe électrolytique'), 'electrolytes'],
      ['libellé « Créatine Monohydrate »', keyFromLabel('Créatine Monohydrate'), 'creatine'],
      ['libellé « Sel Rose Himalaya »', keyFromLabel('Sel Rose Himalaya'), 'pinksalt'],
      ['libellé « Sel Rose de l\'Himalaya »', keyFromLabel('Sel Rose de l\'Himalaya'), 'pinksalt'],
      ['libellé « Glycérol (GlycoPump® 65 %) »', keyFromLabel('Glycérol (GlycoPump® 65 %)'), 'glycerol'],
      ['libellé « L-Tyrosine USP »', keyFromLabel('L-Tyrosine USP'), 'tyrosine'],
      /* La bétaïne est SORTIE du produit (V1135/V1136) : elle ne doit jamais être reconnue ici, sans
         quoi un rachat la réinjecterait dans une commande. Sa clé reste vivante dans MNL_DOSES
         (position 7 des QR imprimés) — c'est le module qui la neutralise, pas nous. */
      ['bétaïne hors liste blanche', keyFromLabel('Bétaïne'), ''],
      ['libellé inconnu → chaîne vide', keyFromLabel('Saveur'), '']
    ];
    var ko = cas.filter(function (c) { return c[1] !== c[2]; });
    return { ok: ko.length === 0, total: cas.length, echecs: ko, cas: cas, empreinteModule: d.FINGERPRINT };
  }

  /* ═══ V1292 (09/08/2026) — LE RÉCAP DES CHANGEMENTS AU RACHAT ═══════════════════════════════
     Arbitrage fondateur du 06/08, mot pour mot : « s'il souhaite recommander avec le qr code alors
     le récap lui affiche les changements ». Les passes V1256→V1260 convertissaient JUSTE mais EN
     SILENCE ; ce bloc ajoute l'obligation d'affichage. Il vit ICI parce que les trois portes de
     rachat (fiche QR, order.liquid, carte compte) chargent déjà ce module : un seul texte, un seul
     rendu, pas trois récaps qui divergent.
     · recapTexte(diffs) est PUR (testable au banc) : diffs = [{label, avant, apres}] en chaînes
       déjà formatées. C'est lui que lit le repli window.confirm quand le DOM n'est pas disponible.
     · montrerRecapChangements N'EST PAS UN BLOQUEUR de fabrication (règle : « Ne bloque JAMAIS la
       fabrication. Alerte plutôt. ») — c'est un écran de consentement d'ACHAT : le client voit,
       puis décide. Annuler ne casse rien : le bouton d'origine redevient cliquable. */
  function recapTexte(diffs) {
    var l = ['Ta formule a évolué avec la grille du jour — le prix suit le cran, pas les milligrammes.', ''];
    for (var i = 0; i < (diffs || []).length; i++) {
      var d = diffs[i];
      l.push('· ' + d.label + ' : ' + d.avant + ' → ' + d.apres);
    }
    l.push('');
    l.push('La recette déjà commandée, elle, n\'a pas bougé : ce récap ne concerne que la nouvelle commande.');
    return l.join('\n');
  }
  function montrerRecapChangements(opts) {
    opts = opts || {};
    var diffs = opts.diffs || [];
    var onOk = typeof opts.onOk === 'function' ? opts.onOk : function () {};
    var onCancel = typeof opts.onCancel === 'function' ? opts.onCancel : function () {};
    if (!diffs.length) { onOk(); return; }
    if (!document || !document.body) {
      if (window.confirm(recapTexte(diffs) + '\n\nContinuer avec la formule d\'aujourd\'hui ?')) onOk(); else onCancel();
      return;
    }
    var ov = document.createElement('div');
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Ta formule a évolué');
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(16,20,24,.62);display:flex;align-items:center;justify-content:center;padding:18px;';
    var card = document.createElement('div');
    card.style.cssText = 'background:#fff;border-radius:16px;max-width:440px;width:100%;max-height:82vh;overflow:auto;padding:22px 22px 18px;font-family:inherit;color:#0f172a;box-shadow:0 24px 64px rgba(0,0,0,.28);';
    var h = document.createElement('div');
    h.style.cssText = 'font-size:17px;font-weight:800;letter-spacing:-.2px;margin-bottom:6px;';
    h.textContent = 'Ta formule a évolué';
    var sub = document.createElement('p');
    sub.style.cssText = 'margin:0 0 14px;font-size:13px;line-height:1.55;color:#475569;';
    sub.textContent = 'La grille des doses a été mise à jour depuis cette commande. Voici ce qui change — le prix suit le cran, pas les milligrammes.';
    card.appendChild(h); card.appendChild(sub);
    for (var i = 0; i < diffs.length; i++) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;justify-content:space-between;gap:12px;padding:8px 0;border-top:1px solid #eef2f7;font-size:14px;';
      var nm = document.createElement('span'); nm.style.cssText = 'font-weight:700;'; nm.textContent = diffs[i].label;
      var vals = document.createElement('span');
      var av = document.createElement('s'); av.style.cssText = 'opacity:.55;font-weight:400;margin-right:7px;'; av.textContent = diffs[i].avant;
      var ap = document.createElement('b'); ap.textContent = diffs[i].apres;
      vals.appendChild(av); vals.appendChild(ap);
      row.appendChild(nm); row.appendChild(vals); card.appendChild(row);
    }
    var note = document.createElement('p');
    note.style.cssText = 'margin:12px 0 16px;font-size:12px;line-height:1.55;color:#64748b;';
    note.textContent = 'La recette que tu as déjà reçue, elle, n\'a pas bougé : ceci ne concerne que la nouvelle commande.';
    card.appendChild(note);
    var ctas = document.createElement('div');
    ctas.style.cssText = 'display:flex;gap:10px;flex-wrap:wrap;';
    function fermer() { try { document.removeEventListener('keydown', surTouche, true); ov.remove(); } catch (_) {} }
    var ok = document.createElement('button'); ok.type = 'button';
    ok.style.cssText = 'flex:1;min-width:180px;background:#E84E1B;color:#fff;border:0;border-radius:11px;padding:13px 16px;font-size:14px;font-weight:700;cursor:pointer;';
    ok.textContent = 'Continuer avec la formule d\'aujourd\'hui';
    ok.onclick = function () { fermer(); onOk(); };
    var ko = document.createElement('button'); ko.type = 'button';
    ko.style.cssText = 'background:#fff;color:#0f172a;border:1.5px solid #d7dde5;border-radius:11px;padding:13px 16px;font-size:14px;font-weight:700;cursor:pointer;';
    ko.textContent = 'Annuler';
    ko.onclick = function () { fermer(); onCancel(); };
    function surTouche(ev) { if (ev.key === 'Escape') { ev.stopPropagation(); fermer(); onCancel(); } }
    document.addEventListener('keydown', surTouche, true);
    ctas.appendChild(ok); ctas.appendChild(ko); card.appendChild(ctas);
    ov.appendChild(card); document.body.appendChild(ov);
    try { ok.focus(); } catch (_) {}
  }

  return {
    VERSION: 'V1259',
    DATE: '2026-08-06',
    ALIAS: ALIAS, LABEL: LABEL, UNIT: UNIT,
    TS_V1228: TS_V1228, TS_V1236: TS_V1236, TS_V1253: TS_V1253,
    ready: ready,
    requireModule: requireModule,
    keyFromLabel: keyFromLabel,
    mgOf: mgOf,
    toDisplay: toDisplay,
    toMg: toMg,
    fmtDose: fmtDose,
    eraGrid: eraGrid,
    convert: convert,
    convertMg: convertMg,
    convertRaw: convertRaw,
    snapToRung: snapToRung,
    normalizeActifs: normalizeActifs,
    normalizeDoses: normalizeDoses,
    recapTexte: recapTexte,
    montrerRecapChangements: montrerRecapChangements,
    selfTest: selfTest
  };
}));
